// extracted by mini-css-extract-plugin
export default {"root":"L1PB2JXgr3U5C7ZEx_Nl","placeHolderShimmer":"DJfk1kI7qj5k6dKJ40Gm"};